const TipoPagoIsrRetOptions = [
  {
    label: 'Selecciona',
    value: ''
  },
  {
    label: "Pago definitivo ISR (03)",
    value: "03"
  },
  {
    label: "Pago provisional ISR (04)",
    value: "04"
  }
];

export default TipoPagoIsrRetOptions;